import {https,httpsFile} from './http.js';
export function index(search){
    return httpsFile().get(`/asset?search=${search}`);
}
